module.exports = __webpack_public_path__ + "static/media/LoginImage.89842e54.jpg";